import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import isAuthenticated from '../../../redux/auth/authUtils';
import {
  closeExperienceForm,
  fetchUserExperiences,
  openFeedbackForm,
  updateUserExperience,
} from '../../../redux/feedback/feedback-slice';
import { useAppDispatch } from '../../../redux/store';
import { RootState } from '../../../redux/types';
import { UserExperience } from '../../../types/instant-lease-api';
import Modal from '../../b2b/components/modal/modal';
import RadioContainer from '../../b2b/components/radio-container/radio-container';
import Radio from '../../b2b/components/radio/radio';
import './snacker.css';

interface SnackerForm {
  experience: UserExperience.Experience;
}

const Snacker: React.FC = () => {
  const auth = useSelector((state: RootState) => state.auth);
  const { activeApplication } = useSelector(
    (state: RootState) => state.leaseApp,
  );
  const { experienceForm } = useSelector((state: RootState) => state.feedback);
  const dispatch = useAppDispatch();
  const { watch, setValue, handleSubmit } = useForm<SnackerForm>();

  useEffect(() => {
    activeApplication?.customer?.uuid &&
      dispatch(fetchUserExperiences({ auth }));
  }, [activeApplication?.customer?.uuid, auth, dispatch]);

  const close = () => dispatch(closeExperienceForm());

  const options = [
    { value: 'a', label: 'Nicht so gut', icon: '😖' },
    { value: 'b', label: 'War ok', icon: '😐' },
    { value: 'c', label: 'Sehr gut', icon: '🤩' },
  ];

  const submitData = ({ experience }: SnackerForm) => {
    activeApplication?.uuid &&
      dispatch(
        updateUserExperience({
          accessToken: auth.accessToken,
          leaseApplicationId: activeApplication?.uuid,
          experience,
        }),
      )
        .then(close)
        .then(() => dispatch(openFeedbackForm()));
  };

  return isAuthenticated(auth) && activeApplication?.uuid ? (
    <div className='snacker'>
      <Modal
        className='snacker'
        closeButtonVisibility
        showCloseButtonForMobile={true}
        isOpen={experienceForm.isOpened}
        onClose={close}
        type='middle'
        direction='up'
        background='transparent'
      >
        <h1 className='title'>Wie zufrieden warst du mit uns?</h1>
        <form>
          <RadioContainer>
            <div className='flex flex-row gap-2'>
              {options.map(({ value, label, icon }) => (
                <div key={value}>
                  <Radio
                    value={watch('experience') || ''}
                    checked={watch('experience') === value}
                    onChange={() => {
                      setValue(
                        'experience',
                        value as UserExperience.Experience,
                      );
                      handleSubmit(submitData)();
                    }}
                  >
                    <div className='snacker-radio-content w-40'>
                      <div className='heading'> {icon}</div>
                      <p className='label only-mobile content-normal'>
                        {label}
                      </p>
                    </div>
                  </Radio>
                </div>
              ))}
            </div>
          </RadioContainer>
        </form>
      </Modal>
    </div>
  ) : null;
};

export default Snacker;
